// Keep search destinations aligned with AppLayout's PermissionRoutes. Unknown
// destinations fail closed until their route permission is explicitly mapped.
const ROUTE_RULES = [
  ['/operations/property-defaults', ['operations.property_defaults']],
  ['/settings/chat', ['messaging.chatbot']], ['/settings/five-star', ['messaging.surveys']],
  ['/settings/smart-locks', ['admin.integrations']], ['/settings', ['admin.settings']],
  ['/crm/open-tasks', ['operations.tasks']], ['/crm/pipelines', ['crm.pipelines']], ['/crm', ['crm.contacts']],
  ['/operations/standards-structure', ['operations.standards'], 'edit'],
  ['/operations/property-setup', ['operations.standards'], 'edit'],
  ['/operations/inspection-board', ['operations.inspections']],
  ['/operations/survey-board', ['operations.surveys']],
  ['/operations/storage', ['operations.inventory']], ['/operations/checklists', ['operations.checklists']],
  ['/operations/calendar', ['operations.calendar']], ['/operations/team-scheduler', ['operations.calendar']], ['/operations/tasks', ['operations.tasks']],
  ['/operations', ['operations.calendar']], ['/tasks/calendar', ['operations.calendar']],
  ['/tasks', ['operations.tasks']], ['/work-orders', ['operations.work_orders']],
  ['/guide-designer', ['guides.master'], 'edit'], ['/master-home-guide', ['guides.master'], 'edit'],
  ['/properties', ['guides.home']], ['/areas_detail', ['guides.area']], ['/areas', ['guides.area']],
  ['/subscriptions', ['guides.master']], ['/extras', ['guides.extras']],
  ['/orders', ['guides.payments']], ['/payments', ['guides.payments']],
  ['/messages', ['messaging.messages']], ['/guests', ['messaging.guests']], ['/contacts', ['messaging.contacts']],
  ['/scheduler', ['messaging.scheduler']], ['/alerts', ['messaging.alerts']], ['/surveys', ['messaging.surveys']],
  ['/saved-responses', ['messaging.responses']], ['/message-templates', ['messaging.templates']],
  ['/extend-guest-stay', ['messaging.extend_stay']], ['/reports', ['reports']], ['/notes', ['crm.notes']],
  ['/ai-assistant', ['messaging.ai']], ['/chatbot-faqs', ['messaging.chatbot']], ['/unanswered-questions', ['messaging.chatbot']],
  ['/smart-locks', ['admin.integrations']], ['/team', ['admin.users']], ['/zones', ['admin.zones']],
  ['/user-groups', ['admin.users']], ['/roles', ['admin.roles']], ['/billing', ['admin.billing']],
  ['/units', ['admin.units']], ['/unit_detail', ['admin.units']],
  ['/macros', ['admin.macros']], ['/property-field-values', ['admin.settings']], ['/custom-fields', ['crm.custom_fields']],
  ['/todays_bookings', ['operations.calendar']], ['/work-schedules', ['operations.work_schedules']],
  ['/availability-calendar', ['operations.work_schedules']],
];
export const canSearchFeature = (feature, permissions) => {
  if (!permissions?.permsLoaded) return false;
  const path = feature.route.split('?')[0];
  if (path === '/') return permissions.canView('dashboard');
  if (['/profile', '/whats-new', '/features', '/help'].includes(path)) return true;
  const rule = ROUTE_RULES.find(([prefix]) => path === prefix || path.startsWith(prefix + '/'));
  return !!rule && rule[1].some(rule[2] === 'edit' ? permissions.canEdit : permissions.canView);
};
export const SEARCH_MODULES = [...new Set(['dashboard', ...ROUTE_RULES.flatMap(rule => rule[1])])];
export const searchPermissionScope = permissions => JSON.stringify([permissions.permsLoaded,
  ...SEARCH_MODULES.map(key => [permissions.canView(key), permissions.canEdit(key)])]);
export const allowedRecordCategories = (permissions, account) => {
  if (!permissions?.permsLoaded) return [];
  const canView = permissions.canView;
  const people = canView('messaging.contacts') || (canView('crm.contacts') && account.flags?.some(f => f.name === 'crm'));
  return [
    ...(canView('messaging.guests') ? ['bookings'] : []),
    ...(people ? ['owners', 'contacts'] : []),
    ...(canView('guides.home') ? ['home-guides'] : []),
    ...(['operations.tasks', 'operations.work_orders'].some(canView) ? ['tasks'] : []),
  ];
};
